var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "uploadFile" } },
    [
      _c(
        "v-card",
        { attrs: { "max-width": "800px" } },
        [
          _c("v-card-title", { staticClass: "headerTitle" }, [
            _vm._v(" " + _vm._s(_vm.$t("upload-presentation-slides")) + " ")
          ]),
          _c(
            "v-overlay",
            { attrs: { value: _vm.uploadProgress } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" }
              })
            ],
            1
          ),
          _c(
            "v-card-text",
            { attrs: { if: "!validated" } },
            [
              _c("h3", { staticClass: "text-center text-white pt-10" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "as-a-user-you-can-upload-presentation-slides-in-pdf-form-that-are-less-than-10mbs"
                      )
                    ) +
                    " "
                )
              ]),
              _c("h3", { staticClass: "text-center pt-10 red--text" }, [
                _vm._v(" " + _vm._s(_vm.uploadFileError) + " ")
              ]),
              _c("v-card-actions", [
                _c("input", {
                  ref: "userFile",
                  staticClass: "pt-14 mx-auto",
                  attrs: { type: "file", name: "uploadedFile" },
                  on: { change: _vm.selectFile }
                })
              ])
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("br"),
              _c("v-spacer"),
              _vm.exceededMaxFileUploaded
                ? _c("h3", { staticClass: "text-center pt-10 red--text" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "you-have-exceeded-the-maximum-number-of-files-10-that-can-be-uploaded"
                          )
                        ) +
                        " "
                    )
                  ])
                : _vm._e(),
              _c(
                "v-card-actions",
                { staticClass: "pr-14" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red" },
                      on: { click: _vm.cancelUpload }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-auto",
                      attrs: { color: "blue", disabled: !_vm.validated },
                      on: { click: _vm.uploadFile }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("upload-file")) + " ")]
                  )
                ],
                1
              ),
              _c("v-spacer")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }